import { Chat } from "../Chat/Chat";
import Statistics from "../Statistics/Statistics";
import { useLiveSessionStore } from "../../../stores/useLiveSessionStore";
import { useUserContext } from "../../../stores/userContext";
import "./Sidebar.scss";

interface SidebarProps {
  width: number;
  isSendingEngagement: boolean; // Added prop to determine the condition
  // ...other existing
}

export const Sidebar = ({ width, isSendingEngagement }: SidebarProps) => {
  const chatMessages = useLiveSessionStore((state) => state.chatMessages);
  const { user } = useUserContext();

  return (
    <aside
      className="sidebar"
      style={{
        width: width,
      }}
    >
      {isSendingEngagement ? (
        <Statistics />
      ) : (
        <Chat messages={chatMessages} currentUserId={user?.userId} />
      )}
    </aside>
  );
};
